import { render, staticRenderFns } from "./VariantEdit.vue?vue&type=template&id=448e0c8c&scoped=true"
import script from "./VariantEdit.vue?vue&type=script&lang=js"
export * from "./VariantEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448e0c8c",
  null
  
)

export default component.exports